import { OptionsType } from '@openx/types/options.ts';
import type { MetacategoryOptionsMap } from '@openx/types/targeting/metacategory.ts';
import { useOptionsFetch } from '@openx/utils/apiHooks/generics/useOptionsFetch.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { prepareMetacategoryOptions } from '../../Targeting/Metacategories/utils/utils.ts';

export function useMetacategoriesFetch() {
  const { t } = useTranslation();
  const {
    isLoading: areMetacategoriesLoading,
    data: metacategories,
    refetch: refetchMetacategories,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Metacategories'),
    optionType: OptionsType.METACATEGORIES,
    queryOptions: { enabled: false },
  });

  const preparedCategories = useMemo(
    () => prepareMetacategoryOptions(metacategories as MetacategoryOptionsMap),
    [metacategories]
  );

  return {
    areMetacategoriesLoading,
    metacategories: preparedCategories,
    refetchMetacategories,
  };
}
